import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
      <p className="text-gray-500 text-sm mb-8">Last updated: FEB 2026</p>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 space-y-8 text-gray-700 text-sm leading-relaxed">

        <section>
          <p className="text-base">
            At <strong>KLMKart</strong>, we are committed to protecting your privacy. This Privacy
            Policy explains how we collect, use, disclose, and safeguard your information when you visit our
            website <a href="https://klmkart.com" className="text-blue-600 hover:underline">klmkart.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Information We Collect</h2>
          <p className="mb-2">We collect the following types of information:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Personal Information:</strong> Name, email address, phone number, and delivery address when you register or place an order.</li>
            <li><strong>Payment Information:</strong> Payment is processed by our secure payment partners. We do not store card details.</li>
            <li><strong>Usage Data:</strong> Pages visited, products viewed, and interactions on the website.</li>
            <li><strong>Device Information:</strong> Browser type, IP address, and operating system for analytics and security purposes.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">2. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To process and fulfill your orders.</li>
            <li>To send order confirmations, shipping updates, and delivery notifications via SMS or email.</li>
            <li>To respond to your queries and provide customer support.</li>
            <li>To improve our website, products, and services.</li>
            <li>To comply with legal obligations under Indian law.</li>
            <li>To send promotional offers (you may opt-out at any time).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Sharing of Information</h2>
          <p className="mb-2">We do not sell your personal information. We may share your data with:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Shipping Partners:</strong> To fulfill and deliver your orders (via Shiprocket).</li>
            <li><strong>Payment Processors:</strong> To securely handle payment transactions (via PhonePe).</li>
            <li><strong>SMS/Communication Providers:</strong> To send order notifications.</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect our rights.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Data Security</h2>
          <p>
            We implement industry-standard security measures including SSL encryption, secure authentication,
            and access controls to protect your personal information. However, no method of transmission over
            the internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Cookies</h2>
          <p>
            Our website uses cookies to enhance your browsing experience, remember your preferences, and
            analyze website traffic. You may disable cookies through your browser settings, though this may
            affect certain features of our website.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Your Rights</h2>
          <p className="mb-2">You have the right to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access the personal data we hold about you.</li>
            <li>Request correction of inaccurate data.</li>
            <li>Request deletion of your data (subject to legal obligations).</li>
            <li>Opt-out of marketing communications at any time.</li>
          </ul>
          <p className="mt-2">
            To exercise these rights, please contact us at{' '}
            <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the privacy
            practices of those websites and encourage you to read their privacy policies.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with an
            updated revision date. We encourage you to review this policy periodically.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Governing Law</h2>
          <p>
            This Privacy Policy is governed by the laws of India, including the Information Technology Act,
            2000, and applicable rules thereunder.
          </p>
        </section>

        <section className="border-t border-gray-100 pt-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact Us</h2>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p><strong>Company Name:</strong> KLMKart </p>
            <p><strong>Email:</strong> <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a></p>
            <p><strong>Address:</strong> H.NO-8-5-136/12/P,T, S.R. COMPLEX, DURGA NAGAR X ROAD, MAILARDEVPALLY, RAJENDRANAGAR, Rangareddy</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;